module.exports = __webpack_public_path__ + "assets/img/logAudit-module7-1.82602962.jpg";